import styled from '@emotion/styled';
import React, { MouseEvent } from 'react';
import Col from 'react-bootstrap/lib/Col';
import Row from 'react-bootstrap/lib/Row';
import { Link } from 'react-router-dom';
import Field from 'redux-form/lib/Field';
import { ButtonWithHoverAndPress } from '../../shared/Button';
import FacebookIcon from '../FacebookIcon';
import { FieldInputWithRedux } from '../FieldInput';
import GoogleIcon from '../GoogleIcon';
import OutboundLink from '../OutboundLink';
import TwitterIcon from '../TwitterIcon';
import styles from './styles.sass';

const FieldWrapper = styled.div`
  margin-bottom: 14px;
`;

const ButtonWrapper = styled.div`
  margin: auto;
  margin-bottom: 14px;
  margin-top: 32px;
  max-width: 300px;
  width: 100%;
`;

const ErrorAlert = styled.div`
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  background-color: rgba(208, 2, 27, 0.1);
  font-size: 1.2rem;
  color: #e54751;
  margin: 12px 0;
`;

type Props = {
  clickRequestResetPassword: () => void;
  error: string;
  handleSubmit: () => void;
  submitting: boolean;
  showHelpLinks: boolean;
  showSocialLogin: boolean;
  feedUrl: string;
};

export function Login(props: Props) {
  const handleClickRequestResetPassword = (evt: MouseEvent) => {
    const { clickRequestResetPassword } = props;
    evt.preventDefault();
    clickRequestResetPassword();
  };

  const {
    error,
    handleSubmit,
    submitting,
    showHelpLinks,
    showSocialLogin,
    feedUrl,
  } = props;
  const feedUrlQuery = feedUrl ? `?feedUrl=${encodeURIComponent(feedUrl)}` : '';
  const signupUrl = `/signup${feedUrlQuery}`;
  const authTwitterUrl = `/auth/twitter${feedUrlQuery}`;
  const authFacebookUrl = `/login/facebook${feedUrlQuery}`;
  const authGoogleUrl = `/login/google${feedUrlQuery}`;
  // TODO: better handle errors
  let errorString = '';
  if (error) {
    try {
      const errorObj = JSON.parse(error);
      if (errorObj.status === 401) {
        errorString = 'Invalid username or password.';
      } else {
        errorString = 'Unable to log in at this time.';
      }
    } catch (err) {
      errorString = error;
    }
  }
  return (
    <div className={styles.loginForm}>
      <form onSubmit={handleSubmit} id="LoginForm">
        <FieldWrapper>
          <Field
            name="email"
            placeholder="Email"
            component={FieldInputWithRedux}
            type="email"
          />
        </FieldWrapper>
        <FieldWrapper>
          <Field
            name="password"
            placeholder="Password"
            component={FieldInputWithRedux}
            type="password"
          />
        </FieldWrapper>
        {errorString && <ErrorAlert>{errorString}</ErrorAlert>}
        <ButtonWrapper>
          <ButtonWithHoverAndPress
            text="Log in"
            isDisabled={submitting}
            shape="pill"
            type="unelevated"
            colorTheme="primary"
            size="sm"
            isFullWidth={true}
            typeAttribute="submit"
            isEventBubblingAllowed={true}
          />
        </ButtonWrapper>
      </form>
      {showSocialLogin && (
        <Row>
          <Col sm={4} className={styles.socialLogin}>
            <OutboundLink to={authFacebookUrl} style={{ color: '#39579B' }}>
              <FacebookIcon width={24} height={24} /> Facebook
            </OutboundLink>
          </Col>
          <Col sm={4} className={styles.socialLogin}>
            <OutboundLink to={authGoogleUrl} style={{ color: '#8c8c8c' }}>
              <GoogleIcon width={18} height={18} /> Google
            </OutboundLink>
          </Col>
          <Col sm={4} className={styles.socialLogin}>
            <OutboundLink to={authTwitterUrl} style={{ color: '#50ABF1' }}>
              <TwitterIcon width={25} height={20} /> Twitter
            </OutboundLink>
          </Col>
        </Row>
      )}
      {showHelpLinks && (
        <Row>
          <Col sm={12} className={styles.loginFooter}>
            <p style={{ marginBottom: '12px' }}>
              Don't have an account? <Link to={signupUrl}>Sign up</Link>{' '}
              instead.
            </p>
            <p className="text-center">
              <a onClick={handleClickRequestResetPassword}>Forgot password?</a>
            </p>
          </Col>
        </Row>
      )}
    </div>
  );
}

Login.defaultProps = {
  showHelpLinks: true,
  showSocialLogin: true,
};
